var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React from 'react';
export const emptyPaginatedResponse = (pageSize) => __awaiter(void 0, void 0, void 0, function* () {
    return ({
        'items': [],
        'total': 0,
        'page': 1,
        'totalPages': 1,
        pageSize,
    });
});
/**
 * Simple hook to memoize pagination fetch functions for use with PaginatedDataScroller.
 * The network call should already return a Promise (with withDone applied).
 *
 * @example
 * const { fetchData, pageSize } = usePagination(
 *   (page, pageSize) => getPublishedAnnouncements(page, pageSize, filters),
 *   [filters],
 *   { pageSize: 20 }
 * )
 *
 * <PaginatedDataScroller fetchData={fetchData} pageSize={pageSize}>
 *   {item => <ItemCard item={item} />}
 * </PaginatedDataScroller>
 */
export const usePagination = (fetchFn, deps, options = {}) => {
    var _a;
    const pageSize = (_a = options.pageSize) !== null && _a !== void 0 ? _a : 20;
    const fetchData = React.useCallback(fetchFn, deps);
    return {
        fetchData,
        pageSize
    };
};
export default usePagination;
